import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IService } from 'app/services/models/service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from '@fullcalendar/interaction';
import { ISubscription } from 'app/services/models/subscription';
import { ISubscriptionFee } from 'app/services/models/subscriptionFee';
import { ISubscriptionSessions } from 'app/services/models/subscriptionSessions';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { ICompany } from 'app/shared/Domains/company';
import { IBranch } from "app/shared/Domains/branch";
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import {
  Chart as ChartJS,
  PointElement,
  BubbleController
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';

ChartJS.register(
  PointElement,
  BubbleController,
  annotationPlugin
);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  loading: boolean;
  currentChurnRateKPIValue:string;
  lastChurnRateKPIValue:string;
  diffChurnRateKPIValue: string;
  churnRateStatus: string = "NoDiff";
  expandChurnRateKPI: boolean = false;
  currentActiveMembersRateKPIValue:string;
  lastActiveMembersKPIValue:string;
  diffActiveMembersKPIValue: string;
  activeMembersStatus: string = "NoDiff";
  currentNewMembersRateKPIValue:string;
  lastNewMembersKPIValue:string;
  diffNewMembersKPIValue: string;
  newMembersStatus: string = "NoDiff";
  currentSalesRateKPIValue:string;
  lastSalesKPIValue:string;
  diffSalesKPIValue: string;
  salesStatus: string = "NoDiff";
  currentDayPassKPIValue:string;
  lastDayPassKPIValue:string;
  diffDayPassKPIValue: string;
  dayPassStatus: string = "NoDiff";
  currentMembershipFrozenKPIValue:string;
  lastMembershipFrozenKPIValue:string;
  diffMembershipFrozenKPIValue: string;
  membershipFrozenStatus: string = "NoDiff";
  currentTrainerSalesKPIValue:string;
  lastTrainerSalesKPIValue:string;
  diffTrainerSalesKPIValue: string;
  trainerSalesStatus: string = "NoDiff";
  kpiMainState: string = "";
  churnRateValue: number = 0;
  churnRateChartLabel: string;
  chartLabelSummary: string;
  NewMembersRegisteredCount: string;
  totalPackageAmountForChart: string;
  monthOptions: any[] = [];
  yearOptions: any[] = [];
  statusOptions: any[] = [];
  typeOptions: any[] = [];
  monthValue: string;
  yearValue: string;
  statusValue: string;
  typeValue: string;
  company: ICompany;
  companySessionStorage: any;
  branchSessionStorage: any;
  currentUser: string;
  branch: IBranch;
  data: any;
  previousYearSales : any;
  currentYearSales : any;
  currentYear : any;
  previousYear : any;

  public ChurnRateChartType: ChartType = 'doughnut';
  public ChurnRateChartData!: ChartData<'doughnut'>;
  public ChurnRateChartOptions!: ChartConfiguration['options'];

  COLORS = ['rgb(140, 214, 16)', 'rgb(239, 198, 0)', 'rgb(231, 24, 49)'];

  public ActiveMembersChartType: ChartType = 'bar';
  public ActiveMembersChartData!: ChartData<'bar'>;
  public ActiveMembersChartOptions!: ChartConfiguration<'bar'>['options'];
  public ActiveMembersDataLabels = DataLabelsPlugin;

  public NewMembersRegisteredChartType: ChartType = 'doughnut';
  public NewMembersRegisteredChartData!: ChartData<'doughnut'>;
  public NewMembersRegisteredChartOptions!: ChartConfiguration<'doughnut'>['options'];
  public NewMembersRegisteredDataLabels = DataLabelsPlugin;

  public DailyMemberAttendanceChartType: ChartType = 'line';
  public DailyMemberAttendanceChartData!: ChartData<'line'>;
  public DailyMemberAttendanceChartOptions!: ChartConfiguration<'line'>['options'];
  public DailyMemberAttendanceDataLabels = DataLabelsPlugin;

  public monthWiseSalesChartType: ChartType = 'line';
  public monthWiseSalesChartData!: ChartData<'line'>;
  public monthWiseSalesChartOptions!: ChartConfiguration<'line'>['options'];
  public monthWiseSalesChartLabels: string[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  public monthWiseSalesDataLabels = DataLabelsPlugin;
  public monthWiseSalesChartTitle = "";

  public packageWiseSalesChartType: ChartType = 'doughnut';
  public packageWiseSalesChartData!: ChartData<'doughnut'>;
  public packageWiseSalesChartOptions!: ChartConfiguration<'doughnut'>['options'];
  public packageWiseSalesChartLabels: string[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  public packageWiseSalesDataLabels = DataLabelsPlugin;


  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    public confirmationService: ConfirmationService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: "/dashboard" },
      { label: "Dashboard" }
    ]);
  }
  ngOnInit() {
    this.currentUser = localStorage.getItem('currentUser');
    const currentUseroBJ = JSON.parse(this.currentUser);
    this.companySessionStorage = currentUseroBJ.company;
    this.branchSessionStorage = currentUseroBJ.branch;
    this.monthOptions = [
      { label: "January", value: '1' },
      { label: "February", value: '2' },
      { label: "March", value: '3' },
      { label: "April", value: '4' },
      { label: "May", value: '5' },
      { label: "June", value: '6' },
      { label: "July", value: '7' },
      { label: "August", value: '8' },
      { label: "September", value: '9' },
      { label: "October", value: '10' },
      { label: "November", value: '11' },
      { label: "December", value: '12' }
    ];

    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear;
    this.company = new ICompany();
    this.branch = AuthService.getLoggedInCurrentBranch();
    this.yearOptions = [];
    for (let year = startYear; year <= endYear; year++) {
      this.yearOptions.push({ label: year.toString(), value: year.toString() });
    }

    this.statusOptions = [
      { label: "All", value: 'All' },
      { label: "Approved", value: 'Approved' },
      { label: "Pending", value: 'Pending' },
      { label: "Reject", value: 'Reject' }
    ];
    this.typeOptions = [
      { label: "All", value: 'All' },
      { label: "Visitor", value: 'Visitor' },
      { label: "Registration", value: 'Registration' },
      { label: "Fee Submission", value: 'Fee Submission' }
    ];
    this.data = {
      totalSales: 0,
      newMemberRegistered: 0,
      defaulters: 0,
      activeCustomers: 0,
      activemembersthismonth:10,
      visitors: 0,
      enquiries: 0,
    };
    this.statusValue = 'All';
    this.typeValue = 'All';
    const dateNow = new Date();
    this.monthValue = (dateNow.getMonth() + 1).toString(); // getMonth() returns 0-11, so add 1
    this.yearValue = currentYear.toString();
    this.getUpdatedData();

    this.getChurnRateData();
    this.getTotalSalesData();
    this.getNewMembersStats();
    this.getDayPassStats();
    this.getFrozenMemberStats();
    this.getAttendanceData();
    this.getTrainerStatus();
    this.getActiveMembersStatus();
    this.getMonthWiseSalesChartData();
    this.getPackageWiseSalesChartData();
    this.getNewMembersRegisteredChartData();
    this.getTotalActiveMembersStatus();


  }

  getAttendanceData() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getAttendanceStats/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {

          this.drawDailyMemberAttendanceChart(res);
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }
  drawMonthWiseSaleChart(){

     let currentYear = this.currentYear + " Sales";
    let LastYear = this.previousYear + " Sales";

    this.monthWiseSalesChartTitle = "2024-25";

    let currentYearData = this.currentYearSales;
    let LastYearData = this.previousYearSales;

    const allValues = [...LastYearData, ...currentYearData];

    let minValue = allValues[0];
    let maxValue = allValues[0];

    allValues.forEach(val => {
      if (val != null){
        if (val < minValue){
          minValue = val;
        }
        if (val > maxValue){
          maxValue = val;
        }
      }
    });

  this.monthWiseSalesChartData = {
    labels: this.monthWiseSalesChartLabels,
    datasets: [
      {
        data: currentYearData,
        label: currentYear,
        borderColor: '#42A5F5',
        backgroundColor: 'rgba(66, 165, 245, 0.2)',
        tension: 0.4,
        fill: false,
      },
      {
        data: LastYearData,
        label: LastYear,
        borderColor: '#9CCC65',
        backgroundColor: 'rgba(156, 204, 101, 0.2)',
        tension: 0.4,
        fill: false,
      }
    ]
  };

  this.monthWiseSalesChartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: true,
        position: 'top'
      },
  // @ts-ignore
      datalabels: {
      display: true,
      anchor: (ctx) => {
        return ctx.dataset.label === currentYear ? 'end' : 'start';
      },
      align: (ctx) => {
        return ctx.dataset.label === currentYear ? 'top' : 'bottom';
      },
      formatter: (value: number) => {
        if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + 'B';
        if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M';
        if (value >= 1_000) return (value / 1_000).toFixed(1) + 'K';
        return value;
      },
      font: {
        weight: 'bold'
      }
    }
    },
    scales: {
      y: {
        beginAtZero: false,
        suggestedMin: minValue - 10,
        suggestedMax: maxValue + 200000,
        ticks: {
          callback: function (value: number) {
            if (value >= 1_000_000_000) return (value / 1_000_000_000) + 'B';
            if (value >= 1_000_000) return (value / 1_000_000) + 'M';
            if (value >= 1_000) return (value / 1_000) + 'K';
            return value;
          }
        }
      }
    }
  };
  }

drawPackageWiseSales(packageData) {
  const packagesData = packageData;

  const labels = packagesData.map(pkg => pkg.packageName);
  const data = packagesData.map(pkg => pkg.packageCurrentData);
  const backgroundColors = packagesData.map(pkg => pkg.color);

  this.packageWiseSalesChartData = {
    labels,
    datasets: [
      {
        label: 'Total Sales by Package',
        data,
        backgroundColor: backgroundColors
      }
    ]
  };

  this.packageWiseSalesChartOptions = {
    responsive: true,
    cutout: '50%',
  layout: {
    padding: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20
    }
  },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: true,
      clamp: true, // Ensures label stays within chart area
      clip: false,
        formatter: (value: number, context: any) => {
          let formattedValue = value.toString();
          if (value >= 1_000_000_000) formattedValue = (value / 1_000_000_000).toFixed(1) + 'B';
          else if (value >= 1_000_000) formattedValue = (value / 1_000_000).toFixed(1) + 'M';
          else if (value >= 1_000) formattedValue = (value / 1_000).toFixed(1) + 'K';

          const label = context.chart.data.labels[context.dataIndex];
          return `${label} (${formattedValue})`;
        },
        color: '#000',
        font: {
          weight: 'bold'
        }
      }
    }
  };
}

  getRandomValue(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  index(perc: number): number {
    return perc < 10 ? 0 : perc < 50 ? 1 : 2;
  }

  drawChurnRateKpi(lastValue, currentValue) {
    if (lastValue == undefined && currentValue != undefined) {
      this.currentChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.lastChurnRateKPIValue = "No Data";
      this.diffChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.churnRateStatus = "churnRateUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentChurnRateKPIValue = "No Data";
      this.lastChurnRateKPIValue = lastValue.toFixed(2) + "%";
      this.diffChurnRateKPIValue = lastValue.toFixed(2) + "%";
      this.churnRateStatus = "churnRateDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentChurnRateKPIValue = "No Data";
      this.lastChurnRateKPIValue = "No Data";
      this.diffChurnRateKPIValue = "0";
      this.churnRateStatus = "NoDiff";
    }
    else {
      this.currentChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.lastChurnRateKPIValue = lastValue.toFixed(2) + "%";

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffChurnRateKPIValue = diff.toFixed(2) + "%";
        this.churnRateStatus = "churnRateUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffChurnRateKPIValue = diff.toFixed(2) + "%";
        this.churnRateStatus = "churnRateDown";
      }
      else {
        this.diffChurnRateKPIValue = "0";
        this.churnRateStatus = "NoDiff";
      }
    }
  }

  drawMembershipFrozenKpi(currentValue, lastValue){

  if(lastValue == undefined && currentValue != undefined){
      this.currentMembershipFrozenKPIValue = currentValue.toString();
      this.lastMembershipFrozenKPIValue = "No Data";
      this.diffMembershipFrozenKPIValue = currentValue.toString();
      this.membershipFrozenStatus = "frozenMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentMembershipFrozenKPIValue = "No Data";
        this.lastMembershipFrozenKPIValue = lastValue.toString();
        this.diffMembershipFrozenKPIValue =  lastValue.toString();
        this.membershipFrozenStatus = "frozenMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentMembershipFrozenKPIValue = "No Data";
      this.lastMembershipFrozenKPIValue = "No Data";
      this.diffMembershipFrozenKPIValue = "0";
      this.membershipFrozenStatus = "NoDiff";
    }
    else{
      this.currentMembershipFrozenKPIValue = currentValue.toString();
      this.lastMembershipFrozenKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffMembershipFrozenKPIValue = diff.toString();
        this.membershipFrozenStatus = "frozenMemberUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffMembershipFrozenKPIValue = diff.toString();
        this.membershipFrozenStatus = "frozenMemberDown";
      }
      else{
        this.diffMembershipFrozenKPIValue =  "0";
        this.membershipFrozenStatus = "NoDiff";
      }
    }
  }

  drawChurnRateChart(currentValue, lastMonthValue){
    if(typeof(currentValue) != "number"){
      currentValue = Number(currentValue);
    }

    if(typeof(lastMonthValue) != "number"){
      lastMonthValue = Number(lastMonthValue);
    }

    const perc = currentValue;
    this.churnRateValue = currentValue;
    this.churnRateChartLabel = currentValue.toFixed(0) +"%";
    if(currentValue > lastMonthValue){
      let diff = currentValue - lastMonthValue;
      this.chartLabelSummary = diff.toFixed(2) +"% higher than last month.";
    }
    else if(lastMonthValue > currentValue){
      let diff = lastMonthValue - currentValue;
      this.chartLabelSummary = diff.toFixed(2) +"% lower than last month.";
    }
    else{
      this.chartLabelSummary = "unchanged from last month.";
    }
    this.ChurnRateChartData = {
      datasets: [{
        data: [perc, 100 - perc],
        backgroundColor: (ctx: any) => {
          if (ctx.index === 1) return 'rgb(234, 234, 234)';
          return this.COLORS[this.index(ctx.raw)];
        }
      }]
    };

    this.ChurnRateChartOptions = {
      responsive: true,
      aspectRatio: 2,
  // @ts-ignore
      cutout: '86%',
  // @ts-ignore
    circumference: 180,
  // @ts-ignore
    rotation: -90,
      plugins: {
        annotation: {
          annotations: {
            label: {
              // @ts-ignore
              enabled: false
            }
          }
        }
      }
    };
  }

  getChurnRateStyle() {
    const num = Number(this.churnRateValue);
    if (isNaN(num)) return {};

    return { color: this.COLORS[this.index(this.churnRateValue)] };
  }

  drawActiveMembersKpi(currentValue, lastValue){
    if (lastValue == undefined && currentValue != undefined) {
      this.currentActiveMembersRateKPIValue = currentValue.toString();
      this.lastActiveMembersKPIValue = "No Data";
      this.diffActiveMembersKPIValue = currentValue.toString();
      this.activeMembersStatus = "activeMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentActiveMembersRateKPIValue = "No Data";
      this.lastActiveMembersKPIValue = lastValue.toString();
      this.diffActiveMembersKPIValue = lastValue.toString();
      this.activeMembersStatus = "activeMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentActiveMembersRateKPIValue ="No Data";
      this.lastActiveMembersKPIValue ="No Data";
      this.diffActiveMembersKPIValue = "0";
      this.activeMembersStatus = "NoDiff";
    }
    else {
      this.currentActiveMembersRateKPIValue = currentValue.toString();
      this.lastActiveMembersKPIValue = lastValue.toString();

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffActiveMembersKPIValue = diff.toString();
        this.activeMembersStatus = "activeMemberUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffActiveMembersKPIValue = diff.toString();
        this.activeMembersStatus = "activeMemberDown";
      }
      else {
        this.diffActiveMembersKPIValue = "0";
        this.activeMembersStatus = "NoDiff";
      }
    }

  }

  drawActiveMembersChart(activeMembersData){
    let labels = [];
    let data = [];
    activeMembersData.forEach(activeMemberData => {
      labels.push(activeMemberData.label);
      data.push(activeMemberData.value.toFixed(0));
    });

    this.ActiveMembersChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        label: 'Active Members',
        borderColor: 'blue',
        backgroundColor: 'blue'
      }
    ]
  };

  this.ActiveMembersChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      y: {
        ticks: {
          autoSkip: false // ensures all labels show
        }
      }
    },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: { display: false },
  // @ts-ignore
      datalabels:{
        display: true,
        color: '#fff',
        font: {
          weight: 'bold'
        }
      }
    }
  };
  setTimeout(() => {
    document.getElementById("activeChartContainer").style.height = '503px';
      setTimeout(() => {
      document.getElementById("activeChartContainer").style.height = '504px';
    }, 100);
  }, 1000);
  }

  drawDayPassKpi(currentValue, lastValue){
    if(lastValue == undefined && currentValue != undefined){
      this.currentDayPassKPIValue = currentValue.toString();
      this.lastDayPassKPIValue = "No Data";
      this.diffDayPassKPIValue = currentValue.toString();
      this.dayPassStatus = "salesUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentDayPassKPIValue = "No Data";
        this.lastDayPassKPIValue = lastValue.toString();
        this.diffDayPassKPIValue =  lastValue.toString();
        this.dayPassStatus = "salesDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentDayPassKPIValue = "No Data";
        this.lastDayPassKPIValue = "No Data";
        this.diffDayPassKPIValue =  "0";
        this.dayPassStatus = "NoDiff";
    }
    else{
      this.currentDayPassKPIValue = currentValue.toString();
      this.lastDayPassKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffDayPassKPIValue = diff.toString();
        this.dayPassStatus = "salesUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffDayPassKPIValue = diff.toString();
        this.dayPassStatus = "salesDown";
      }
      else{
        this.diffDayPassKPIValue =  "0";
        this.dayPassStatus = "NoDiff";
      }
    }
  }

  drawNewMembersRegisteredChart(newMembersRegisteredData){
    let labels = [];
    let data = [];
    let total = 0;
    newMembersRegisteredData.forEach(newMemberRegisteredData => {
      labels.push(newMemberRegisteredData.label);
      data.push(newMemberRegisteredData.value.toFixed(0));
      total += newMemberRegisteredData.value;
    });

  const backgroundColors = newMembersRegisteredData.map(pkg => pkg.color);

    this.NewMembersRegisteredCount = total.toFixed(0);

    this.NewMembersRegisteredChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: backgroundColors
      }
    ]
  };
    this.NewMembersRegisteredChartOptions = {
    responsive: true,
    cutout: '50%',
  layout: {
    padding: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20
    }
  },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: true,
      clamp: true, // Ensures label stays within chart area
      clip: false,
        formatter: (value: number, context: any) => {
          let formattedValue = value.toString();
          const label = context.chart.data.labels[context.dataIndex];
          return `${label} (${formattedValue})`;
        },
        color: '#000',
        font: {
          weight: 'bold'
        }
      }
    }
  };
  }

  drawDailyMemberAttendanceChart(activeMembersData){
    let labels = [];
    let data = [];
    let allValues = [];
    activeMembersData.forEach(activeMemberData => {
      labels.push(activeMemberData.label);
      if(activeMemberData.value == null){
      data.push(null);
      }
      else{
      data.push(activeMemberData.value.toFixed(0));
      }

      allValues.push(activeMemberData.value);
    });

    let minValue = allValues[0];
    let maxValue = allValues[0];

    allValues.forEach(val => {
      if (val != null){
        if (val < minValue){
          minValue = val;
        }
        if (val > maxValue){
          maxValue = val;
        }
      }
    });

    this.DailyMemberAttendanceChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        label: 'Active Members',
        fill: false,
        tension: 0.4,
        borderColor: 'blue',
        backgroundColor: 'rgba(0,0,255,0.1)'
      }
    ]
  };

  this.DailyMemberAttendanceChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: { display: false },
  // @ts-ignore
      datalabels:{
        anchor: 'start',
        align: 'top',
        display: true,
        formatter: (value: number) => {
          return value;
        },
        color: '#000',
        font: {
          weight: 'bold'
        }
      }
    },
    scales: {
      y: {
        beginAtZero: false,
        suggestedMin: minValue - 10,
        suggestedMax: maxValue + 10,
      }
    }
  };
  setTimeout(() => {
    document.getElementById("memberAttendencechartid").style.height = '167px';
      setTimeout(() => {
      document.getElementById("memberAttendencechartid").style.height = '250px';
    }, 100);
  }, 1000);

  }

  drawSalesKpi(currentValue, lastValue){

    if(lastValue == undefined && currentValue != undefined){
      this.currentSalesRateKPIValue = currentValue.toString();
      this.lastSalesKPIValue = lastValue;

      this.diffSalesKPIValue = currentValue.toString();
      this.salesStatus = "salesUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentSalesRateKPIValue = currentValue;
        this.lastSalesKPIValue = lastValue.toString();
        this.diffSalesKPIValue =  lastValue.toString();
        this.salesStatus = "salesDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentSalesRateKPIValue = currentValue;
        this.lastSalesKPIValue = lastValue;
        this.diffSalesKPIValue =  "0";
        this.salesStatus = "NoDiff";
    }
    else{
      this.currentSalesRateKPIValue = currentValue.toString();
      this.lastSalesKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffSalesKPIValue = diff.toString();
        this.salesStatus = "salesUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffSalesKPIValue = diff.toString();
        this.salesStatus = "salesDown";
      }
      else{
        this.diffSalesKPIValue =  "0";
        this.salesStatus = "NoDiff";
      }
    }
  }

  drawNewMembersKpi(currentValue, lastValue){
   if(lastValue == undefined && currentValue != undefined){
      this.currentNewMembersRateKPIValue = currentValue.toString();
      this.lastNewMembersKPIValue = "No Data";
      this.diffNewMembersKPIValue = currentValue.toString();
      this.newMembersStatus = "newMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentNewMembersRateKPIValue = "No Data";
        this.lastNewMembersKPIValue = lastValue.toString();
        this.diffNewMembersKPIValue =  lastValue.toString();
        this.newMembersStatus = "newMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentNewMembersRateKPIValue = "No Data";
        this.lastNewMembersKPIValue = "No Data";
        this.diffNewMembersKPIValue = "0";
        this.newMembersStatus = "NoDiff";
    }
    else{
      this.currentNewMembersRateKPIValue = currentValue.toString();
      this.lastNewMembersKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffNewMembersKPIValue = diff.toString();
        this.newMembersStatus = "newMemberUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffNewMembersKPIValue = diff.toString();
        this.newMembersStatus = "newMemberDown";
      }
      else{
        this.diffNewMembersKPIValue =  "0";
        this.newMembersStatus = "NoDiff";
      }
    }


  }

  drawTrainerSaleKpi(currentValue, lastValue) {
    if (lastValue == undefined && currentValue != undefined) {
      this.currentTrainerSalesKPIValue = currentValue.toString();
      this.lastTrainerSalesKPIValue = lastValue;

      this.diffTrainerSalesKPIValue = currentValue.toString();
      this.trainerSalesStatus = "salesTrainerUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentTrainerSalesKPIValue = currentValue;
      this.lastTrainerSalesKPIValue = lastValue.toString();
      this.diffTrainerSalesKPIValue = lastValue.toString();
      this.trainerSalesStatus = "salesTrainerDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentTrainerSalesKPIValue = currentValue;
      this.lastTrainerSalesKPIValue = lastValue;
      this.diffTrainerSalesKPIValue = "0";
      this.trainerSalesStatus = "NoDiff";
    }
    else {
      this.currentTrainerSalesKPIValue = currentValue.toString();
      this.lastTrainerSalesKPIValue = lastValue.toString();

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffTrainerSalesKPIValue = diff.toString();
        this.trainerSalesStatus = "salesTrainerUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffTrainerSalesKPIValue = diff.toString();
        this.trainerSalesStatus = "salesTrainerDown";
      }
      else {
        this.diffTrainerSalesKPIValue = "0";
        this.trainerSalesStatus = "NoDiff";
      }
    }

  }

  showChurnRateChart(){
    this.expandChurnRateKPI = !this.expandChurnRateKPI;
    this.kpiMainState = this.expandChurnRateKPI ? "transformed" : "";
  }

  onChange(){
    this.getUpdatedData();
    this.getChurnRateData();
    this.getTotalSalesData();
    this.getNewMembersStats();
    this.getDayPassStats();
    this.getFrozenMemberStats();
    this.getAttendanceData();
    this.getActiveMembersStatus();
    this.getTrainerStatus();
    this.getMonthWiseSalesChartData();
    this.getPackageWiseSalesChartData();
    this.getNewMembersRegisteredChartData();

  }

  getUpdatedData(){
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getMonthStats/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
          if (res) {
            if(res.length > 0 ){
              this.data = res[0];
              this.data.activemembersthismonth = this.data.activeCustomers - this.data.defaulters;
              this.loading=false;
            }
            else{
              this.data = {
                totalSales: 0,
                newMemberRegistered: 0,
                defaulters: 0,
                activeCustomers: 0,
                activemembersthismonth: 0,
                visitors: 0,
                enquiries: 0,
              };
              this.loading=false;
            }

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }


  getChurnRateData(){
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getChurnRateData/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
          if (res) {

              this.drawChurnRateChart(res.currentMonthChurn, res.previousMonthChurn);
              this.drawChurnRateKpi(res.previousMonthChurn, res.currentMonthChurn);
              this.loading=false;

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTotalSalesData() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getTotalSalesData/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawSalesKpi(res.currentMonthSales, res.previousMonthSales)
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getDayPassStats() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getDayPassStats/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawDayPassKpi(res.currentMonthVisitors, res.previousMonthVisitors);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getNewMembersStats() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getNewMembersStats/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawNewMembersKpi(res.currentMonthNewMembers, res.previousMonthNewMembers);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getFrozenMemberStats() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getFrozenMemberStats/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawMembershipFrozenKpi(res.currentMonthFrozenMembers, res.previousMonthFrozenMembers);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTrainerStatus(){
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getTrainerStatus/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
          if (res) {
              this.drawTrainerSaleKpi(res.currentTotal, res.previousTotal);
              this.loading=false;
      
        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getActiveMembersStatus(){
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getActiveMembersStatus/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
          if (res) {
              this.drawActiveMembersKpi(res.currentMonthActiveMembers, res.prevMonthActiveMembers);
              this.loading=false;
      
        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getMonthWiseSalesChartData() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getMonthWiseSalesChartData/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.currentYearSales = res.currentYearData;
          this.previousYearSales = res.previousYearData;
          this.currentYear = res.currentYear;
          this.previousYear = res.previousYear;
          this.drawMonthWiseSaleChart();
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getPackageWiseSalesChartData() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getPackageWiseSalesChartData/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawPackageWiseSales(res.topFivePackages);
          this.totalPackageAmountForChart = res.packageTotal;
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getNewMembersRegisteredChartData() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getNewMembersRegisteredChartData/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawNewMembersRegisteredChart(res.topFivePackages);
          this.NewMembersRegisteredCount = res.totalCount;
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTotalActiveMembersStatus() {
    this.loading = true;
    this.appServiceManager.get('statsDashboard/getTotalActiveMembersStatus/month/' + this.monthValue + '/year/' + this.yearValue + '/branch/' + this.branch._id).subscribe(
      (res) => {
        if (res) {
          this.drawActiveMembersChart(res.activeMembersData);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("DashboardComponent", label);
  }
}
